const productTypeEnum = {
  HVAC: { value: 'Hvac', name: 'Heating & Cooling System' },
  WATER_HEATER: { value: 'WaterHeater', name: 'Water Heater' },
  REPAIR: { value: 'Repair', name: 'Repair' },
};

export default productTypeEnum;
